import * as yup from "yup"
import { ImmagineAtlante, ImmagineAtlanteFormType } from "../../types"

export function initialValuesImmagineAtlante(immagine?: ImmagineAtlante | ImmagineAtlanteFormType | undefined) {
  if (immagine) {
    return immagine
  }
  return {
    titolo: "",
    immagine: "",
    descrizione: "",
    ordine: 0,
  }
}

export function validationSchemaImmagineAtlante() {
  
  return yup.object().shape({
    titolo: yup.string().required("Campo obbligatorio"),
    immagine: yup.string().required("Campo obbligatorio"),
  })
}
